export const datHangNcc = {
  sections: { list: { title: '供应商订货' }, detail: { title: '订货详情' } },
  titles: { add: '新建订货单' },
  columns: {
    code: '单号',
    summary: '信息',
    status: '状态',
    ngayTao: '创建时间',
    ngayCapNhat: '更新时间',
    nhaCungCap: '供应商',
    ngayDat: '订货日期',
    ngayNhapDuKien: '预计到货',
    tongTienHang: '商品总额',
    maPhieuNhapKho: '入库单',
  },
  filter: { searchPlaceholder: '搜索...' },
  filters: { hintSection: '提示', hintBody: '使用搜索。' },
  status: {
    phieuTam: '草稿单',
    daXacNhanNCC: '供应商已确认',
    nhapMotPhan: '部分入库',
    hoanThanh: '已完成',
    daHuy: '已取消',
  },
  form: {
    supplier: '供应商',
    code: '订货单号',
    codeAuto: '留空自动生成',
    orderDate: '订货日期',
    expectedDate: '预计到货',
    trangThai: '状态',
    phiVanChuyen: '运费',
    tienNCCTraLai: '供应商退款',
    giamGiaPhieu: '整单折扣',
    giamGiaPhanTram: '折扣 (%)',
    giamGiaHieuLuc: '已应用折扣',
    note: '备注',
    lines: '订货明细',
    addLine: '新增行',
    product: '商品',
    productName: '商品名称',
    productSearch: '搜索编码/名称',
    qty: '数量',
    unitPrice: '单价',
    discount: '折扣',
    discountPercent: '折扣 (%)',
    editDiscount: '折扣设置',
    byAmount: '按金额',
    byPercent: '按百分比',
    currency: '₫',
    lineNote: '行备注',
    lineAmount: '金额',
    tongTienHang: '商品总额',
    tienTraNcc: '已付供应商',
    canTraNCC: '应付',
    datHangNhap: '下单入库',
    thanhToan: '付款',
    phuongThucThanhToan: '付款方式',
    tienMat: '现金',
    the: '银行卡',
    chuyenKhoan: '转账',
    xong: '完成',
    titleTienTraNcc: '支付给供应商',
  },
  fields: {
    totalAmount: '总金额',
  },
  validation: {
    supplierRequired: '请选择供应商',
    soLuongInvalid: '第 {row} 行（{name}）：数量必须大于 0',
    donGiaInvalid: '第 {row} 行（{name}）：单价不能为负数',
    expectedBeforeOrder: '预计入库日期不能早于订货日期',
  },
  messages: {
    loadError: '加载失败。',
    deleteSuccess: '已删除。',
    noData: '暂无数据。',
    noLines: '暂无明细。',
    listSummary: '共 {count} 条',
    createSuccess: '已创建采购单。',
    updateSuccess: '已更新采购单。',
    needLines: '请至少添加一行商品。',
    confirmDelete: '删除单据 {name}？',
    copySuccess: '已复制采购单。',
    completeSuccess: '已结束采购单。',
    cancelSuccess: '已取消采购单。',
    importSuccess: '商品导入成功。',
  },
  detailTabs: {
    generalInfo: '基本信息',
  },
  placeholders: { formTitle: '创建/编辑', formBody: '完整表单将后续补充。' },
  actions: {
    createPhieuNhan: '创建收货单',
    copy: '复制',
    complete: '结束',
    cancelVoucher: '取消单据',
    importExcel: '导入 Excel',
    downloadTemplate: '下载模板',
  },
  emptyState: {
    title: '从 Excel 文件导入商品',
    downloadTemplate: '（下载模板：订货导入文件）',
    chooseFile: '选择数据文件',
    hint: '列：商品编码、商品名称、单位、单价、折扣、数量。商品编码必须与系统中已有编码一致。',
    noSheet: '文件没有数据工作表。',
    noData: '没有有效的数据行。',
    importPartial: '已导入 {success}/{total} 行。',
    someUnmatched: '{count} 行未找到匹配的商品编码。',
    allUnmatched: '没有行匹配编码（共 {total} 行）。',
  },
  aria: {
    columnPicker: '选择显示列',
  },
}
